if (!customElements.get('toggle-tab')) {
let pwToggleId = 0;
class ToggleTab extends HTMLElement {
constructor() {
super();
this.titleEl = this.querySelector('[data-js-title]');
this.contentEl = this.querySelector('[data-js-content]');
if (!this.titleEl || !this.contentEl) return;
this.titleEl.insertAdjacentHTML('beforeend', "<span class=\"toggle__icon toggle__icon-alternate\"><svg class=\"pw-icon\" viewBox=\"0 0 24 24\" width=\"20\" height=\"20\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"m6 9 6 6 6-6\"/></svg></span>");
this.toggleInert = this.hasAttribute('data-toggle-inert');
if (!this.contentEl.id) this.contentEl.id = 'pw-toggle-' + (++pwToggleId);
this.titleEl.setAttribute('aria-controls', this.contentEl.id);
if (this.titleEl.tagName !== 'BUTTON') { this.titleEl.setAttribute('role','button'); this.titleEl.tabIndex = 0; }
this.syncState();
this.titleEl.addEventListener('click', () => this.onClickHandler());
this.titleEl.addEventListener('keydown', e => {
if (this.titleEl.tagName !== 'BUTTON' && (e.key === 'Enter' || e.key === ' ')) {e.preventDefault();this.titleEl.click();}
});
}
syncState() {
const open = this.classList.contains('opened');
this.titleEl.setAttribute('aria-expanded', String(open));
this.contentEl.style.display = open ? 'block' : 'none';
this.contentEl.setAttribute('aria-hidden', String(!open));
if (this.toggleInert) this.contentEl.toggleAttribute('inert', !open);
}
onClickHandler() {
this.classList.toggle('opened');this.syncState();
if (this.classList.contains('opened')) this.contentEl.querySelector('css-slider')?.resetSlider();
}
}
customElements.define('toggle-tab', ToggleTab);
}
if (!customElements.get('toggle-group')) {
class ToggleGroup extends HTMLElement {
constructor(){super();this.querySelectorAll('toggle-tab').forEach(tab=>{tab.querySelector('[data-js-title]')?.addEventListener('click',()=>{this.querySelectorAll('toggle-tab.opened').forEach(open=>{if(open!==tab)open.onClickHandler();});});});}
}
customElements.define('toggle-group',ToggleGroup);
}